import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=0516091e&scoped=true&"
import script from "./ListView.vue?vue&type=script&lang=ts&"
export * from "./ListView.vue?vue&type=script&lang=ts&"
import style0 from "./ListView.vue?vue&type=style&index=0&id=0516091e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516091e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VToolbar})
